import { render, staticRenderFns } from "./Internal.vue?vue&type=template&id=0c485d5d&"
import script from "./Internal.vue?vue&type=script&lang=js&"
export * from "./Internal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports